import get from 'growth-payments-core/object/get';
import NetworkBinding from 'growth-payments-core/binding/networkBinding';
import { fetchUserInfo } from '../api/auth';
export const authBinding = new NetworkBinding(fetchUserInfo);
export const getAuth = authBinding.get;
export const getUser = () => {
  return get(getAuth(), 'user');
};